module.exports = __webpack_public_path__ + "img/slogan.c7956177.png";